import React, {Component} from "react";
import axios from "axios";
import { CategoryData } from "../components/CategoryData";
import { ArticleData } from "../components/ArticleData";
import PageNav from "../partials/PageNav";
import { DetailArticle } from "../components/DetailArticle";

class DetailCategory extends Component{

    state = {
        category : [],
        categories : [],
    }

    async getCategory (){
        let category = await axios.get(`categories/${ this.props.match.params.id }`)
        if(category.status == 200){
            this.setState({ category : category.data })
        }
    }

    async getCategories (){
        let categories = await axios.get('categories')
        if(categories.status == 200){
            this.setState({ categories : categories.data })
        }
    }

    componentDidMount(){
        this.getCategory()
        this.getCategories()
        this.refreshToken()
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token.data.data);
              localStorage.setItem("user", JSON.stringify(user));
          }
          else if(token.status === 401)
          {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
          }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
        }
    }

    render(){
        var category = null, articleFirst = false, articles = [];
        this.state.category.map((cat) => {
            if(cat.id == this.props.match.params.id)
                category = cat
            cat.articles.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1).map((article) => {
                if(!articleFirst)
                    articleFirst = article
                articles.push(article)
            })
        })
        
        let pageNav = PageNav( category ? ( category.name + " " + category.description ) : "" ,  "/categories/" + this.props.match.params.id,  "/logo192.png",  category ? category.name : "",  category ? ( category.description ) : "" );
        
        return(
            <main id="main">
                { pageNav}
                    
                <section id="blog" className="blog">
                    <div className="container p-0" data-aos="fade-up">

                        <div className="row">
                            <div className="col-md-9">

                            {
                                articleFirst &&(
                                    <DetailArticle
                                        article={ articleFirst }
                                        comment = ""
                                        categories={this.state.categories.filter(
                                            (cat) => cat.parentId == null
                                        )}
                                    />
                                )
                            }

                                <div className="posts-list row mt-5">
                                {
                                    articles && (<ArticleData articles={ articles } /> )
                                }
                                </div>
                            </div>
                            <div className="col-md-3">
                                <CategoryData categories={ this.state.categories } articles={ articles ? articles.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1 ).filter( data => data.comment != 3).slice(0, 5) : [] } />
                            </div>
                        </div>
                    </div>
                </section>
            </main> 
        )
    }
}
export default DetailCategory;